import amplitude from 'amplitude-js';

const runWhenAmplitudeReady = (callback) => {
  const checkInit = setInterval(() => {
    if (window.sessionStorage.getItem('amplitudeInit') === 'true') {
      callback();
      clearInterval(checkInit);
    }
  }, 500);
};

export const initAmplitude = (userId, callback) => {
  amplitude
    .getInstance()
    .init(process.env.REACT_APP_AMPLITUDE_KEY, userId || null, null, () =>
      callback('amplitude')
    );
};

export const setAmplitudeUserId = (userId) => {
  amplitude.getInstance().setUserId(userId);
};

export const sendAmplitudeData = (eventType, eventParams) => {
  runWhenAmplitudeReady(() => {
    amplitude.getInstance().logEvent(eventType, eventParams);
  });
};

export const setAmplitudeUserProperties = (properties) => {
  runWhenAmplitudeReady(() => {
    amplitude.getInstance().setUserProperties(properties);
  });
};

export const sendAmplitudeRevenue = (eventParams) => {
  const { price, product_id } = eventParams;
  const revenue = new amplitude.Revenue()
    .setProductId(product_id)
    .setPrice(price);

  amplitude.getInstance().logRevenueV2(revenue);
};
